import './DocsExample.css';

import { cn } from '../../cn';

export const cnDocsExample = cn('DocsExample');
